import { render, staticRenderFns } from "./purchase-amount-noti.vue?vue&type=template&id=3d0c1e58&scoped=true&"
import script from "./purchase-amount-noti.vue?vue&type=script&lang=js&"
export * from "./purchase-amount-noti.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount-noti.vue?vue&type=style&index=0&id=3d0c1e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c1e58",
  null
  
)

export default component.exports